import { makeStyles } from '@material-ui/core';

import Logo from './LogoIcon.svg';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img alt="Logo" className={classes.svg} src={Logo} />;
};

export default LogoIcon;
